import * as React from 'react';
import DraggableListItem from './DraggableListItem';
import {
  DragDropContext,
  Droppable,
} from 'react-beautiful-dnd';
import {
  Box,
  Typography
} from "@mui/material";
import { ReactComponent as Nodata } from "../../../assets/icons/nodata.svg";
import { useTranslation } from "react-i18next";

const DraggableList = React.memo(({ items, onDragEnd, search, link, adjust, onDelete }: DraggableListProps) => {
  const { t } = useTranslation();
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.length > 0 ? items.map((item, index) => (
              <DraggableListItem item={item} search={search} index={index} key={item.seq} link={link} adjust={adjust} onDelete={onDelete} />
            ))
              :
              <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                <Nodata />
                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                  {t('label.noDataFilter')}
                </Typography>
                <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                  {t('label.tryChangingFilter')}
                </Typography>
              </Box>
            }
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext >
  );
});

export default DraggableList;
